import React from 'react';
import PropTypes from 'prop-types';
import { videoShape } from '../../utils/shapes';
import withSounds from '../../containers/withSounds/index';
import './VideoListItem.css';

const Img = ({ alt, ...otherProps }) => <img alt={alt} {...otherProps} />;

const ImgWithSounds = withSounds({ mouseEnterSound: true })(Img);

function VideoListItem({ video, onVideoClick, nowPlaying }) {
  const handleVideoClick = () => {
    if (onVideoClick) {
      onVideoClick(video);
    }
  };

  return (
    <li className="video-list-item">
      <div
        className={`video-list-item-wrapper ${nowPlaying
          ? 'now-playing'
          : null}`}
        onClick={handleVideoClick}
      >
        <a title={video.snippet.title}>
          <ImgWithSounds
            src={video.snippet.thumbnails.high.url}
            alt={video.snippet.title}
          />
        </a>
      </div>
    </li>
  );
}

VideoListItem.propTypes = {
  video: videoShape,
  onVideoClick: PropTypes.func,
  nowPlaying: PropTypes.bool
};

export default VideoListItem;



// WEBPACK FOOTER //
// ./src/components/VideoListItem/index.js